import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  overlay: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  root: {
    position: 'relative',
    display: 'inline-flex',
    width: 90,
    height: 90,
  },
  progress: {
    color: isKiteUser ? colors.kite.primary1 : colors.gilead.primary2,
    '& svg': {
      color: isKiteUser ? colors.kite.primary1 : colors.gilead.primary2,
      '& circle': {
        color: isKiteUser ? colors.kite.primary1 : colors.gilead.primary2,
      },
    },
  },
  absoluteProgress: {
    color: `${theme.palette.grey1} !important`,
    position: 'absolute',
    zIndex: -1,
    '& svg': {
      color: `${theme.palette.grey1} !important`,
      '& circle': {
        color: `${theme.palette.grey1} !important`,
      },
    },
  },
}));
